module.exports = __webpack_public_path__ + "static/img/1_5_1.5c939c91.jpg";